import { render, staticRenderFns } from "./option-data.vue?vue&type=template&id=6a0eeef0&scoped=true&"
import script from "./option-data.vue?vue&type=script&lang=js&"
export * from "./option-data.vue?vue&type=script&lang=js&"
import style0 from "./option-data.vue?vue&type=style&index=0&id=6a0eeef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0eeef0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a0eeef0')) {
      api.createRecord('6a0eeef0', component.options)
    } else {
      api.reload('6a0eeef0', component.options)
    }
    module.hot.accept("./option-data.vue?vue&type=template&id=6a0eeef0&scoped=true&", function () {
      api.rerender('6a0eeef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/field-template/option-data.vue"
export default component.exports